import React from 'react'
import { Link } from 'react-router-dom'

export default function CompanyInfrastructure() {
    return (
        <>
            <div className="main">
                <div className='page-head'>
                    <div className="container text-center">
                        <nav>
                            <ol className="breadcrumb mb-2 justify-content-center">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Infrastructure</li>
                            </ol>
                        </nav>
                        <h1>Infrastructure</h1>
                    </div>
                </div>

                <section className='section'>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5">
                                <img src ="assets/images/infrastructure.jpg" className='img-width-100' />
                            </div>
                            <div className="col-lg-1"></div>
                            <div className="col-lg-5">
                                <h3 className='main-title'>Infrastructure</h3>
                                <div className='info-list'>
                                    <ul>
                                        <li>2 LAC+ sqft Land, 15K sqft Building</li>
                                        <li>CNC Universal bed miller 3kX1.5kX1k mm CME Germany</li>
                                        <li>Support for optimum design of the grinding part during the development phase</li>
                                        <li>3 Nos VMC (Cosmos, ACE Mackpower)</li>
                                        <li>5 Nos. CNC Lathe (LMW, ACE, Mackpower)</li>
                                        <li>Horizontal Boring Machine WMW BFT 80</li>
                                        <li>Surface Grinder 800 X 400</li>
                                        <li>NC Universal Cylindrical Grinder (OMICRON)</li>
                                        <li>Broaching machine</li>
                                        <li>Tool and cutter grinder (HMT)</li>
                                        <li>DRO Milling, Taiwan Make</li>
                                        <li>Slotting machine (VOLTAS)</li>
                                        <li>Radial Drill (ARSUN)</li>
                                        <li>Manual & NC pillar drill (6 Nos)</li>
                                        <li>Automatic Metal Cutting Machine</li>
                                        <li>Sapping Machine (Sagar Make)</li>
                                        <li>Riveting Machine</li>
                                        <li>Laser Interferometer, Ball bar tester (Ranisaw make)</li>
                                        <li>All inspection apparatus, surface table, straightedge, precision level, surface roughness tester, ect (MICROFLAT DATTUM)</li>
                                    </ul>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </section>

                <section className='section bg-white'>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5">
                                <img src ="assets/images/r-and-d.jpg" className='img-width-100' />
                            </div>
                            <div className="col-lg-1"></div>
                            <div className="col-lg-5">
                                <h3 className='main-title'>Research & Development</h3>
                                <h4 className='sub-title'>Inhouse Design Software</h4>
                                <div className='info-list'>
                                    <ul>
                                        <li>Solid Edge (2 Licence)</li>
                                        <li>Future CAM</li>
                                        <li>PC Schematic (For Panel Design)</li>
                                        <li>Auto Cad (6 Licence)</li>
                                    </ul>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </section>

            </div>
        </>
    )
}